import type { RandomUUID } from '@/src/common/utils/randomUUID'

export function randomUUID() {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  return crypto.randomUUID()
}

randomUUID satisfies RandomUUID
